import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';
import error404 from './../../assets/images/error404/error404.png'
// Styled Components
const Root = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  textAlign: 'center',
  backgroundColor: '#f8f9fa',
  color: '#333',
 
});

const Content = styled(Box)({
  textAlign: 'left',
  maxWidth: '800px',
});

const Big404 = styled(Typography)({
  fontSize: '200px',
  fontWeight: 'bold',
  color: '#0056b3',
  lineHeight: '1',
});

const ImageBox = styled(Box)({
 
  minWidth: '300px',
});

const HomeButton = styled(Button)({
  backgroundColor: '#0056b3',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#004494',
  },
});

const Error404 = () => {
    useEffect(() => {
        // Disable scrolling when component is mounted
        document.body.style.overflow = 'hidden';
    
        // Enable scrolling when component is unmounted
        return () => {
          document.body.style.overflow = 'auto';
        };
      }, []);
  return (
    <Root sx={{flexDirection:{xs:"column",md:"row"}  ,  position: "fixed",
    top: 0,
    left: 0,
    zIndex: 2000, display: "flex",
    width: "100%",  }}>
      {/* Left Side: 404 and Image */}
      <ImageBox sx={{width:"50%"}}>
        
        <img
          src={error404} 
          alt="Tools and Helmet"
           loading="lazy"
          style={{ maxWidth: '100%', height: 'auto',width:"1800px" }}
        />
      </ImageBox>

      {/* Right Side: Text Content */}
      <Content sx={{ p: "0 13px" }}>
  <Typography
    variant="h4"
    gutterBottom
    sx={{
      color: "#000",
      fontSize: { xs: "32px", sm: "40px", md: "48px", xl: "64px" }, // Responsive font sizes
      fontWeight: 700,
    }}
  >
    <span
      style={{
        color: "#12538B",
        fontSize: "inherit", // Inherit font size from parent
        fontWeight: 700,
      }}
    >
      Ooops!
    </span>
    <br /> That Link Is Broken.
  </Typography>
  <Typography
    variant="body1"
    paragraph
    sx={{
      color: "#000000C7",
      fontSize: { xs: "14px", sm: "16px", md: "18px", xl: "20px" }, // Adjust body text size
    }}
  >
    Page does not exist or some other error occurred. Go to our{' '}
    <a
      href="/"
      style={{
        textDecoration: 'underline',
        fontWeight: 'bold',
        color: '#000',
      }}
    >
      Home page
    </a>
    .
  </Typography>
  <HomeButton
    variant="contained"
    href="/"
    sx={{
      backgroundColor: "#12538B",
      borderRadius: "2px",
      fontWeight: 900,
      fontSize: { xs: "16px", sm: "18px", md: "20px", xl: "24px" }, // Adjust button font size
      padding: "10px 20px",
      mb: 2,
    }}
  >
    Go To Home
  </HomeButton>
</Content>

    </Root>
  );
};

export default Error404;